<template>
  <div class="page-content">
    <headBox title="角色权限"></headBox>
    <div class="content">
      <el-form class="select-form-new follow" :inline="true">
        <el-form-item label="角色名称">
          <el-input v-model="searchParams.nickName" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model="searchParams.account" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <div class="btn-box">
          <el-button class="org-btn small" @click="searchAjax()">查询</el-button>
        </div>
      </el-form>
      <div class="role-list" v-loading="listLoading">
        <div class="role-item add-btn">
          <div class="add-icon"><img src="@static/images/orgManage/add-icon.png" alt=""></div>
          <div class="text5">自定义角色</div>
          <div class="text3">配置自定义角色，并在该角色下配置机构账号，灵活管理平台权限。</div>
          <div class="btn-list">
            <el-button class="org-btn" @click="$refs.editForm.open()">新增角色</el-button>
          </div>
        </div>
        <div class="role-item" v-for="(bean,i) in tableData" :key="i">
          <img src="@static/images/orgManage/user-icon.png" alt="">
          <div class="text-box">
            <p class="text1">{{bean.name}}</p>
            <p class="text2">{{bean.code}}</p>
          </div>
          <p class="text4">此角色目前已配置 <span @click="$refs.userList.open(bean)">{{bean.userNum}}</span> 个账号</p>
          <p class="text3" v-if="isSuper(bean.code)">
            超级管理员拥有全部使用权限，将<span>自动同步</span>系统新菜单。
          </p>
          <p class="text3" v-else>{{bean.remark}}</p>
          <div class="btn-list">
            <el-button class="org-btn" v-if="isSuper(bean.code)" @click="$refs.editForm.open(bean,true)">查看权限</el-button>
            <el-button class="org-btn" v-else @click="$refs.editForm.open(bean)">编辑角色</el-button>
            <el-tooltip class="item" effect="dark" v-if="isSuper(bean.code)||bean.userNum*1" 
              :content="isSuper(bean.code)?'此角色为系统设置角色，无法删除！':'此角色已有账号使用，无法删除！'" placement="top">
              <el-button class="org-btn gray" plain>删除角色</el-button>
            </el-tooltip>
            <el-button v-else class="org-btn" plain @click="del(bean)">删除角色</el-button>
          </div>
        </div>
      </div>
      <el-pagination
        class="page"
        background
        :current-page.sync="pageNum"
        :page-size.sync="pageSize"
        layout="total,prev,pager,next,jumper"
        :total="total"
        @size-change="
          pageNum = 1;
          pageSize = $event;
          getList();
        "
        @current-change="getList"
      ></el-pagination>
    </div>

    <!-- 新增/编辑角色 -->
    <edit-form ref="editForm" @reload="searchAjax()"></edit-form>
    <!-- 角色使用账号列表 -->
    <user-list ref="userList"></user-list>
  </div>
</template>
<script>
import headBox from "@/components/head.vue";
import editForm from "./components/editForm.vue";
import userList from "./components/userList.vue";
import { pageTool } from "@/api/mixins";
export default {
  mixins: [pageTool],
  components: {
    editForm,
    userList,
    headBox,
  },
  data: () => ({
    tableData: [],
    searchParams: {
    },
  }),
  mounted() {
    this.initListAjax("/master/mechanRole/list");
  },
  methods: {
    isSuper(code){
      return ['000001','000002','000003','000004'].includes(code)
    },
    setListParams(params) {
      params.pageSize = 11;
    },
    del(item){
      this.$confirm('请确认是否删除角色?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http({
          url:'/master/mechanRole/deleteById',
          type:'GET',
          params:{
            id:item.id,
          },
        }).then(res=>{
          this.$message.success("角色删除成功");
          this.searchAjax();
        })
      })
    },
    
  },
};
</script>
<style lang="scss" scoped>
@import "@/components/topSearchForm";
@import "./roleList.scss";
</style>

